//$(document).ready(function(){
  $('.bxslider').bxSlider();
//});

// Find all YouTube videos
var $allVideos = $("iframe[src^='//www.youtube.com']"),

    // The element that is fluid width
    $fluidEl = $("body");

// Figure out and save aspect ratio for each video
$allVideos.each(function() {

  $(this)
    .data('aspectRatio', this.height / this.width)

    // and remove the hard coded width/height
    .removeAttr('height')
    .removeAttr('width');

});

// When the window is resized
$(window).resize(function() {

  var newWidth = $fluidEl.width();

  // Resize all videos according to their own aspect ratio
  $allVideos.each(function() {

    var $el = $(this);
    $el
      .width(newWidth)
      .height(newWidth * $el.data('aspectRatio'));

  });

// Kick off one resize to fix all videos on page load
}).resize();
  

//Header Resizing
 
$(window).on("scroll touchmove", function () {
  $('header').toggleClass('tiny', $(document).scrollTop() > 85);
  $('.brand img').toggleClass('tinyShift', $(document).scrollTop() > 85);
  $('.brand img').toggleClass('shift', $(document).scrollTop() > 85);
  $('.mobileMenu').toggleClass('shift', $(document).scrollTop() > 85);
  $('.mobileCart').toggleClass('shift', $(document).scrollTop() > 85);
  $('.brandText').toggleClass('shift', $(document).scrollTop() > 85);


});


  
 $('div.trigger').on('mouseover', function () {
  $('header').removeClass('tiny');
  $('.brand img').removeClass('tinyShift');
  $('.brand img').removeClass('shift');
  $('.mobileMenu').removeClass('shift');
  $('.mobileCart').removeClass('shift');
  $('.brandText').removeClass('shift');

});
  

//  $('header').on('click', function () {

//  });


  



